import {useMemo} from 'react';
import {useApp} from '@app';
import {LocationApplication} from '@application/Site';
import {ConfigurationApplication} from '@application/Config';

export const DEVICE = {DESKTOP: 'Desktop', MOBILE: 'Mobile'} as const;

const MATCH_MOBILE = /^Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/i;

export const useScope = (): Map<string, string> => {
  const {authorization} = useApp();

  return useMemo(() => {
    const store = LocationApplication.getStore();

    const userAgent = navigator.userAgent && navigator.userAgent.toLowerCase();
    const mobile = Boolean(userAgent?.match(MATCH_MOBILE));
    const {tradename} = ConfigurationApplication.retrieve();
    const device = mobile ? DEVICE.MOBILE : DEVICE.DESKTOP;

    const scope = new Map<string, string>();
    scope.set('store', store);
    scope.set('registered', Boolean(authorization).toString());
    scope.set('device', device);
    scope.set('tradename', tradename);

    return scope;
  }, [authorization]);
};
